module.exports = __webpack_public_path__ + "img/normanton-park-v4-singapore-scaled.5466426c.gif";